import { render, staticRenderFns } from "./listadoObsequio.vue?vue&type=template&id=10dd079f&scoped=true"
import script from "./listadoObsequio.vue?vue&type=script&lang=js"
export * from "./listadoObsequio.vue?vue&type=script&lang=js"
import style0 from "./listadoObsequio.vue?vue&type=style&index=0&id=10dd079f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dd079f",
  null
  
)

export default component.exports